export default __webpack_public_path__ + "static/media/heart-reversed.41953979.svg";